import type { EventTypes } from '@web-platform/global-components-utils/tracking';

const cookieBannerTrackingEvent = (action: string): EventTypes[] => [
  {
    topic: 'tracking-event',
    data: {
      ga: [
        {
          category: 'cookie-banner',
          action: `Cookie Policy ${action}`,
        },
      ],
    },
  },
];

export { cookieBannerTrackingEvent };
